import { Menu, Moon, Sun } from 'lucide-react';
import { NotificationsPanel } from '@/components/layout/NotificationsPanel';
import { ProfileMenu } from '@/components/layout/ProfileMenu';
import { WorkspaceSwitcher } from '@/components/layout/WorkspaceSwitcher';
import { useTheme } from '@/hooks/useTheme';

interface TopbarProps {
  onOpenMobileMenu: () => void;
}

/** Top bar — organization switcher on the left, theme/notifications/profile on the right. Search and the sidebar collapse toggle live in the Sidebar. */
export function Topbar({ onOpenMobileMenu }: TopbarProps) {
  const { resolvedTheme, toggle } = useTheme();

  return (
    <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-gray-100 bg-white/90 px-4 py-2.5 backdrop-blur-md dark:border-gray-800 dark:bg-gray-900/90 sm:px-6">
      <button
        type="button"
        onClick={onOpenMobileMenu}
        aria-label="Open menu"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 md:hidden"
      >
        <Menu className="h-5 w-5" />
      </button>

      <WorkspaceSwitcher variant="navbar" />

      <div className="min-w-0 flex-1" />

      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={toggle}
          aria-label="Toggle theme"
          className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-100"
        >
          {resolvedTheme === 'dark' ? <Sun className="h-[18px] w-[18px]" /> : <Moon className="h-[18px] w-[18px]" />}
        </button>
        <NotificationsPanel />
        <div className="mx-1 hidden h-6 w-px bg-gray-200 dark:bg-gray-800 sm:block" />
        <ProfileMenu />
      </div>
    </header>
  );
}
